import { ContentSection, Text } from '@cinch-labs/design-system'
import {
  getStoryblokImageServiceUrl,
  storyblokEditable,
} from '@cinch-nx/data-storyblok'
import { renderWithResolver } from '@cinch-nx/landing-ui-shared'

import type { IntroSection as IntroProps } from '../../types/our-commitment-page'
import styles from './intro.module.css'

export const Intro: React.FC<IntroProps> = (blok) => {
  const { title, body, image } = blok

  return (
    <section {...storyblokEditable(blok)}>
      <Text
        fontSize="xxl"
        fontWeight="bold"
        element="h2"
        lineHeight="display"
        className={styles.title}
      >
        {title}
      </Text>
      <ContentSection>{renderWithResolver(body)}</ContentSection>
      <div className={styles.imageContainer}>
        <img
          src={getStoryblokImageServiceUrl(image.filename, {
            width: 900,
            filters: [{ quality: 50 }],
          })}
          className={styles.image}
          alt={image.alt ?? undefined}
        />
      </div>
    </section>
  )
}
